




































































import { computed, defineComponent, toRefs } from '@vue/composition-api';
import QuotaDetailsContainer from '../quota-detail-container/index.vue';
import QuotaStepInfo from '../quota-step-info/index.vue';
import StepLegend from '../step-legend/index.vue';
import { PropType } from 'vue';
import { Ios14Quota } from '@tt4b/ttam-enums';
import AppleIcon from '@tt4b/ttam-assets/src/svgs/apple.svg';

const name = 'ttam-ios14-info-quota-detail-split-test';
export default defineComponent({
  name,
  components: { AppleIcon, StepLegend, QuotaStepInfo, QuotaDetailsContainer },
  props: {
    ios14Quota: {
      type: Object as PropType<Ios14Quota>,
    },
    appName: {
      type: String,
    },
  },
  setup(props) {
    const { ios14Quota } = toRefs(props);
    const quotaTotal = computed(() => ios14Quota.value?.splitTestQuota?.totalQuota);
    const quotaRemain = computed(() => ios14Quota.value?.splitTestQuota?.availableQuota);
    const quotaReleasing = computed(() => ios14Quota.value?.splitTestQuota?.releasingQuota);
    const quotaUsed = computed(() => ios14Quota.value?.splitTestQuota?.usedQuota);

    const legends = computed(() =>
      [quotaUsed.value > 0 && 'used', quotaReleasing.value > 0 && 'reset', 'unused'].filter(Boolean)
    );

    return {
      name,
      quotaUsed,
      quotaTotal,
      quotaRemain,
      quotaReleasing,
      legends,
    };
  },
});
